import { Component } from "@angular/core";
import { LiveAnnouncer } from '@angular/cdk/a11y';

@Component({
    selector: 'app-payment-error',
    templateUrl: './payment-error.component.html'
  })
  export class PaymentErrorComponent {
    constructor(private liveAnnouncer: LiveAnnouncer){
      this.liveAnnouncer.announce('Payment Error');
    }
  }